import Home from '../../animations/videos-nav-2.0.json';
import Cartoons from '../../animations/cartoons-nav-2.0.json';
import Games from '../../animations/games-nav-2.0.json';
import Live from '../../animations/live-nav-2.0.json';

const Menus = [Home, Live, Games, Cartoons];

export default Menus;
